<template>
    <md-dialog-content v-if="renderComponent">
      <div class="container">
        <section v-if="options.isUploading" class="loading_spinner">
          <div class="ladebalken">
            <div class="custom-spinner"></div>
          </div>
        </section>
        <div class="pt-30">
          <table class="tableclass2-timeline">
            <tr>
              <td class="name" style="padding-left: 8px;">
                {{options.Lang.Absender}}
              </td>
              <td class="date" style="padding-left: 0px;">
                {{options.Lang.Datum}}
              </td>
              <td class="trip-details" style="padding-left: 0px;">
                {{options.Lang.Betreff}}
              </td>
              <td class="address1" style="padding-left: 0px;">
                {{options.Lang.Empfänger}}
              </td>
              <td class="address2" style="padding-left: 8px;">
                Supplier
              </td>
              <td class="cc" style="padding-left: 0px;">
                CC-Mail
              </td>
              <td class="prev" style="padding-left: 0px;">
                loupe
              </td>
            </tr>

          </table>
          <p v-if="mails[0].length <= 0" style="margin: auto; text-align: center; padding-top: 30px">{{ options.Lang.keine_Emails_gefunden }}</p>
          <table  v-else class="tableclass" v-on:click="getMailContent(mail.form.message)" v-for="(mail, index) in mails[0]" :key="index">
            <tr>
              <td class="name" style="padding-left:8px;">
                {{ mail.firstname + " " + mail.lastname }}
              </td>
              <td class="date">
                {{ moment(mail.date).format("DD.MM.YY - HH:mm") }}
              </td>
              <td class="trip-details">
                <label v-for="(trip, index) in mail.tripDetails" :key="index">
                  {{ trip.name + " - " + trip.categorie }}<br v-if="index !== mail.tripDetails.length - 1">
                  <br v-if="index !== mail.tripDetails.length - 1">
                  <div v-if="trip?.room && trip?.room != ''">
                    <label>{{options.Lang.Room}}: {{ trip?.room }}</label>
                    <br>
                  </div>
                  <div v-if="trip.zusatz">
                    <label v-if="trip.zusatz.length > 0">{{options.Lang.Zusatzleistungen}}:<br></label>
                    <span v-for="(zusatz, index) in trip.zusatz" :key="index">
                      {{ zusatz.name }}
                    </span>
                  </div>
                  <hr v-if="index !== mail.tripDetails.length - 1"><br>
                </label>
              </td>
              <td class="address1">
                {{ mail.form.email ? mail.form.email : options.Lang.keine_Angabe }}
              </td>
              <td class="address2">
                {{ mail.form.supplier != '999999999' ? mail.form.supplier : options.Lang.keine_Angabe }}
              </td>
              <td class="cc">
                {{ mail.form.cc_email ? mail.form.cc_email : options.Lang.keine_Angabe }}
              </td>
              <td class="pointer">
                <span>
                  <md-icon
                    style="color:transparent">travel_explore
                  </md-icon>
                </span>
              </td>
            </tr>
            <div class="spacer"></div>
          </table>
        </div>
      </div>
      <!--////////-->
      <Error class="errorDialog" v-if="options.showError && options.user.loggedIn" :options="options"></Error>
    </md-dialog-content>
    <!--showMail-->
<!--    <div v-if="options.showSuccessHtml" class="showMail md-elevation-10">
      <strong>E-mail</strong>
      <div class="email-container">
        <div v-html="options.successMsgHtml"></div>
      </div>
      <div class="pr-30 center">
        <md-button class="md-raised secondary" @click="options.showSuccessHtml = false"><strong>{{ options.Lang.Fenster_schließen }}</strong></md-button>
      </div>
    </div>-->
</template>

<script>
import * as moment from 'moment'
import { validationMixin } from 'vuelidate'
import Error from './Error.vue'
import SuccessHtml from './SuccessHtml.vue'


export default {
  name: 'formTimeline',
  mixins: [validationMixin],
  components: {
    Error,
    //SuccessHtml
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    currentTrip: {
      type: Object
    },
  },
  data: () => ({
    trip: null,
    renderComponent: false,
    mails: [],
    supplier: "",
    tripAlias: null
  }),
  created() {
  },
  async mounted() {
    this.trip = this.currentTrip;
    console.log(this.trip, "CURRENT TRIP");
    let test = await this.loadJsonField('trip_details');
    this.tripAlias = test.data.attributes.alias;
    this.getTimeline();
  },
  watch: {

  },
  methods: {
    async loadJsonField(key) {
      const trip = this.currentTrip ? this.currentTrip : null;
      const jsonPath = trip.json_path;

      const payload = {
        data: {
          file_path: jsonPath,
          key: key
        }
      };

      let self = this;

      return new Promise(resolve => {
        this.doPost(payload, 'json/findFieldInJsonFile', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
            return resolve(null);
          }
          resolve(res.data.value);   // return extracted JSON field
        });
      });
    },
    getMailContent(message) {
      this.options.successMsgHtml = message;
      this.options.showSuccessHtml = true;
    },
    async getTimeline() {
      let self = this;
      await this.doPost({ data: self.trip.offer_id }, 'getTimeline', async function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let toParse = res.data.data[0].timeline;
          //console.log(toParse, "ERGEBNIS DB");
          let withoutLeer = toParse.replaceAll("\n","");
          let wihtout2 = withoutLeer.replaceAll(`<ol start="22">`, `<ol start='22'>`);
          self.mails.push(JSON.parse(wihtout2));
          self.mails[0].reverse();
          //console.log(self.mails, "MAILS");
          ////

          ////
          await self.getSupplier();
        }
      });
    },
    openDialog() {
      //do stuff
    },
    async getSupplier() {
      let self = this;
      await self.mails[0].forEach(element => {
        let id = element.form.supplierid;
        if (isNaN(id)) {
            id = element.form.supplier;
        }
        this.doPost({ data: id }, 'getSuppById', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            let result = res.data.data
            element.form.supplier = result[0]?.supplier_name ? result[0]?.supplier_name : "";
          }
        });
      })
      this.renderComponent = false;

// Wait for the change to get flushed to the DOM
await this.$nextTick();

// Add the component back in
this.renderComponent = true;

    },
    closeDialog() {
      this.options.showTimelineForm = false;
      this.options.showSuccessHtml = false;
      this.options.currentTrip = null;
      this.mails = []
    },
    refreshDialog() {
      let self = this;
      self.options.showUploadPdfForm = false;
      self.$nextTick(() => {
        // Adding the component back in
        this.options.isUploading = false;
        self.options.showUploadPdfForm = true;
      });
    },
    moment(date) {
      return moment(date)
    }

  }
}
//hier weiter machen, nur noch die div mittig machen, ansonsten gut so
</script>
<style lang="scss">
.md-dialog-content:first-child {
  padding-top: 22px;
  padding-bottom: 50px;
}


.dialog {
  width: 100%;
}

.container {
  padding: 30px;
}

.showMail {
  position: absolute;
  left: 15%;
  min-width: 780px;
  max-width: 780px;
  margin: 0 auto;
  height: 100%;
  padding-left: 40px;
  padding-right: 40px;
  overflow-y: auto;
  background-color: white;
  border: 30px solid #8FA1B4;
  z-index: 33;
}

.email-container {
  background-color: #F5F6FA;
  padding: 18px;
  margin-top: 10px;
  margin-bottom: 70px;
  border: 0.6000000238418579px solid #D5D5D5;
}

.tableclass {
  width: 100%;
  min-height: 70px;
  padding: 5px 5px;
  vertical-align: bottom;
  border-collapse: collapse;
}

.tableclass:hover {
  cursor: inherit;
}

.pointer:hover {
  cursor: pointer;
}

.tableclass2-timeline {
  width: 100%;
  height: 48px;
  padding-left: 50px;
  vertical-align: center !important;
  border-collapse: collapse;
  background: #E1E8F3;
  opacity: 1;

  font-weight: bold;
  border-radius: 10px;
}

.tableclass td {
  padding: 5px;
  vertical-align: center;
  padding-top: 20px !important;
  padding-bottom: 15px !important;
}

.tableclass2-timeline td {
  padding: 5px 15px 5px -5px;
  vertical-align: center !important;
}

.tableclass tr {
  padding: 5px;
  background-color: white !important;
  border-bottom: 0.4000000059604645px solid #97979767;
}

.spacer {
  background-color: white;
  height: 5px;
}

.name {
  width: 11% !important;
}

.date {
  width: 13% !important;
}

.trip-details {
  width: 27%;
}

.address1 {
  width: 18% !important;
}

.address2 {
  width: 20%;
}

.cc {
  width: 15%;
}

.prev {
  width: 10%;
  visibility: hidden;
}

.minH {
  min-height: 50px;
}

.none {
  display: none;
}

.formTD {
  background-color: rgb(249, 249, 249);
  margin-bottom: 5px;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #B6D210;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #B6D210 transparent transparent transparent;
}

.catTR td {
  background-color: white;
}

.label-container {
  display: flex;
  flex-wrap: wrap;
}

.label-left,
.label-right {
  display: flex;
  flex-direction: column;
}

.label-left {
  margin-right: 0px;
}

.label-text {
  font-weight: bold;
  margin-bottom: 10px;
}

.trip-alias {
  min-width: 740px;
}

.nezasa-id {
  min-width: 265px;
}

.nezasa-id,
.trip-alias {
  border: 0.6000000238418579px solid #D5D5D5;
  border-radius: 4px;
  background: #F5F6FA 0% 0% no-repeat padding-box;
  padding: 18px;
  margin-bottom: 15px;
  color: black !important;
}

.asterix {
  color: #EA7C7C;
}

#angebot, #nezasa_id{
  -webkit-text-fill-color: black !important;
}

</style>